import { GridColumnVisibilityModel } from '@cbridge-utils/datagrid';
import { IRuleRowModel } from './RulesDataGrid.interface';

export const DEFAULT_HIDDEN_COLUMNS: GridColumnVisibilityModel<IRuleRowModel> = {
  status: false,
};

// Grid row id of the synthetic "default" rule row
export const DEFAULT_RULE_ROW_ID = -1;

// Details sidebar resource id (URL segment) of the synthetic "default" rule row
export const DEFAULT_RULE_RESOURCE_ID = 'default';
